var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.718111 15.381L13.446 1.2117C14.2271 0.342195 15.4934 0.342195 16.2745 1.2117L29.0024 15.381C29.7834 16.2505 29.7834 17.6603 29.0024 18.5298C28.2213 19.3993 26.955 19.3993 26.174 18.5298L16.8602 8.16129L16.8602 28.5L12.8602 28.5L12.8602 8.16129L3.54654 18.5298C2.76549 19.3993 1.49916 19.3993 0.718111 18.5298C-0.0629378 17.6603 -0.0629378 16.2505 0.718111 15.381Z",
    fill: "#C86026"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportOrange);
export default __webpack_public_path__ + "static/media/ExportOrange.193122a897d3bc6222fa54ab8acd6a95.svg";
export { ForwardRef as ReactComponent };